import { render } from "./TransactionsPage.vue?vue&type=template&id=cc991b6c&scoped=true"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

import "./TransactionsPage.vue?vue&type=style&index=0&id=cc991b6c&scoped=true&lang=css"
import "./TransactionsPage.vue?vue&type=style&index=1&id=cc991b6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc991b6c"]])

export default __exports__